import { render, staticRenderFns } from "./SettingsAccountRegistration.vue?vue&type=template&id=30647151&scoped=true&"
import script from "./SettingsAccountRegistration.vue?vue&type=script&lang=js&"
export * from "./SettingsAccountRegistration.vue?vue&type=script&lang=js&"
import style0 from "./SettingsAccountRegistration.vue?vue&type=style&index=0&id=30647151&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30647151",
  null
  
)

export default component.exports